import React, { useContext } from 'react'
import { FiCode } from 'react-icons/fi'

import MicrocopyContext from '~contexts/MicrocopyContext'

import Breadcrumbs from './Breadcrumbs'

import style from './Source.module.scss'

const Source = ({
  page,
  setDisplaySidebar
}) => {
  const microcopy = useContext(MicrocopyContext)

  const pages = []
  let parentPage = page.parentPage
  while (parentPage) {
    pages.push(parentPage)
    parentPage = parentPage.parentPage
  }
  
  return (
    <div className={style.source}>
      <Breadcrumbs pages={pages.reverse()} page={page} setDisplaySidebar={setDisplaySidebar} />
      { microcopy.code === 'en' && (
        <a href={ page.sourceUrl }>
          <FiCode />
          { microcopy.text('guides.titles.edit_source') }
        </a>
      )}
    </div>
    
  )
}

export default Source
